export { QRPage } from './QRPage';
